
CheckoutV2.Payment.Rewards = function(checkout, payment, isReview) {
	var rewards = this;

	this.label = checkout.config.siteNameFirstWord + ' Rewards';
	this.balance = 0;
	var section = '.js-payment';
	if (isReview)
		section = '.js-review';
	this.sessionKey = 'useRewards';

	if (isReview) {
		this.$wrap = $();
		this.content = $();
		this.$balance = $();
	} else {
		this.$wrap = $('.js-rewards');
		this.$content = $('.js-rewards');
		this.$balance = $('.js-rewards-total');
	}
	//this.$remainingBalance = rewards.$content.find('.payment-method-amt-remaining');
	this.$checkbox = $(section + ' .js-payment-use-rewards');
	this.$label = $(section + ' .js-payment-rewards-wrap label');

	this.init = function() {
		if (!isReview) {
			checkout.session.set({
				'useRewards': 0
			});
		}
		rewards.listen();
	};

	this.listen = function() {
		rewards.$checkbox.off('change');
		rewards.$checkbox.change(function() {
			rewards.changeUseBalance(true)
		});
	};

	this.buildContent = function() {
		var rewardBalance = (parseFloat(checkout.session.get('credits.rewardBalance')) || 0),
			useRewards = checkout.session.get('useRewards') || 0;

		if (rewardBalance > 0) {

			rewards.balance = rewardBalance;
			if ( checkout.currentStepName() != 'review' || section.endsWith( checkout.currentStepName() ) ) {
				$(section + '.js-available-balances').removeClass('js-hide').show();
				$(section + ' .js-payment-rewards-wrap').show();
			}
			rewards.$label.html('Use your $' + rewards.balance.toMoney() + ' ' + rewards.label + ' balance <span class="js-remaining text-success"></span>');
 			rewards.$checkbox.prop('checked', useRewards && payment.cart_totals.values.balances[rewards.label] > 0 );

		} else {
			useRewards = 0;
			$(section + ' .js-payment-rewards-wrap').hide();
		}

		//rewards.$checkbox.prop('checked', useRewards);
		//rewards.changeUseBalance(false);
	};

	this.lock = function() {
		if (!rewards.$checkbox.prop('checked'))
			rewards.$checkbox.attr('disabled', 'disabled');
	};

	this.unlock = function() {
		rewards.$checkbox.removeAttr('disabled');
	};

	this.changeUseBalance = function(userEvent) {
		var useRewards = (rewards.$checkbox.prop('checked') ? 1 : 0);

		if (useRewards)
			rewards.applyBalance(userEvent);
		else
			rewards.removeBalance(userEvent);

		if (checkout.session.get('useRewards') != useRewards) {
			checkout.session.set({
				'useRewards': useRewards
			});

			payment.saved = false;
		}
	};

	this.reApplyBalance = function() {
		if (rewards.$checkbox.prop('checked'))
			rewards.applyBalance(false);
	};

	this.applyBalance = function(userEvent) {
		var usedBalanceTotal = 0;

		for (var i=0; i < payment.balanceMethods.length; i++) {
			var method = payment.balanceMethods[i];

			if (method.label == rewards.label)
				break;
			else
				usedBalanceTotal += (payment.cart_totals.values.balances[method.label] || 0);
		}

		var applyBalance = (
			(parseFloat(payment.cart_totals.values.total) || 0)
			- usedBalanceTotal
		);

		if (applyBalance > rewards.balance)
			applyBalance = rewards.balance;

		applyBalance = (parseFloat(applyBalance.toMoney()) || 0);

		if (applyBalance <= 0) {
			rewards.$checkbox.prop('checked', false);
			rewards.changeUseBalance(false);
			return;
		}

		var remainingBalance = (rewards.balance - applyBalance);

		if (remainingBalance < 0)
			remainingBalance = 0;
		
		if (remainingBalance) {
			rewards.$label.find('.js-remaining').text('($' + remainingBalance.toMoney() + ' remaining)');
		} else {
			rewards.$label.find('.js-remaining').text('');
		}

		payment.changeBalanceMethod(rewards, applyBalance, userEvent);

	};

	this.removeBalance = function(userEvent) {
		if (!payment.methodRequired)
			rewards.lock();
		
		rewards.$label.find('.js-remaining').text('');

		payment.changeBalanceMethod(rewards, 0, userEvent);
	};

	this.init();
};

